import React from "react";
import { Link } from "react-router-dom";

export default function AllPages() {
  const items = (
    <ul className="space-y-2">
      <li key="/clarify-topics">
        <Link
          to="/clarify-topics"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Clarify topics{" "}
          <span className="text-gray-500">(/clarify-topics)</span>
        </Link>
      </li>
      <li key="/dashboard">
        <Link
          to="/dashboard"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Dashboard <span className="text-gray-500">(/dashboard)</span>
        </Link>
      </li>
      <li key="/edit-learning">
        <Link
          to="/edit-learning"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Edit learning <span className="text-gray-500">(/edit-learning)</span>
        </Link>
      </li>
      <li key="/">
        <Link to="/" className="text-blue-600 hover:text-blue-800 font-medium">
          Home <span className="text-gray-500">(/)</span>
        </Link>
      </li>
      <li key="/insert-blog-link">
        <Link
          to="/insert-blog-link"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Insert blog link{" "}
          <span className="text-gray-500">(/insert-blog-link)</span>
        </Link>
      </li>
      <li key="/insert-clarify">
        <Link
          to="/insert-clarify"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Insert clarify{" "}
          <span className="text-gray-500">(/insert-clarify)</span>
        </Link>
      </li>
      <li key="/insert-learning">
        <Link
          to="/insert-learning"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Insert learning{" "}
          <span className="text-gray-500">(/insert-learning)</span>
        </Link>
      </li>
      <li key="/insert-quiz">
        <Link
          to="/insert-quiz"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Insert quiz <span className="text-gray-500">(/insert-quiz)</span>
        </Link>
      </li>
      <li key="/insertquickreview">
        <Link
          to="/insertquickreview"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Insertquickreview{" "}
          <span className="text-gray-500">(/insertquickreview)</span>
        </Link>
      </li>
      <li key="/interactive-playground">
        <Link
          to="/interactive-playground"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Interactive playground{" "}
          <span className="text-gray-500">(/interactive-playground)</span>
        </Link>
      </li>
      <li key="/login">
        <Link
          to="/login"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Login <span className="text-gray-500">(/login)</span>
        </Link>
      </li>
      <li key="/manage-topics">
        <Link
          to="/manage-topics"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Manage topics <span className="text-gray-500">(/manage-topics)</span>
        </Link>
      </li>
      <li key="/math-test">
        <Link
          to="/math-test"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Math test <span className="text-gray-500">(/math-test)</span>
        </Link>
      </li>
      <li key="/upload-image-qa">
        <Link
          to="/upload-image-qa"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Upload image qa{" "}
          <span className="text-gray-500">(/upload-image-qa)</span>
        </Link>
      </li>
    </ul>
  );

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">📑 All Pages</h1>
      {items}
      <div className="mt-6 text-sm text-gray-600">
        This page is auto-generated from <code>App.js</code>. It ignores
        parameterized and wildcard routes.
      </div>
    </div>
  );
}
